/**
 * Centralized button labels for consistent UI messaging across the application.
 * This helps maintain consistency and makes it easier to update button text.
 */

export const BUTTON_LABELS = {
  action: {
    cancel: 'Cancel',
    cancelAll: 'Cancel All',
    close: 'Close',
    closeAll: 'Close All',
    confirm: 'Confirm',
    confirmOrder: 'Confirm Order',
    tryAgain: 'Try Again',
    editTpSl: 'Edit TP/SL',
    placeOrder: 'Place Order',
    limit: 'Limit',
    market: 'Market',
    renewSigner: 'Renew Signer',
    enableOneClickTrading: 'Enable One-Click Trading',
    startTrading: 'Start Trading',
  },
  state: {
    closing: 'Closing...',
    cancelling: 'Cancelling...',
    confirming: 'Confirming...',
    placing: 'Placing...',
    canceling: 'Canceling',
    closingAll: 'Closing All',
  },
} as const;
